import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-nas',
  templateUrl: './page-nas.component.html',
  styleUrls: ['./page-nas.component.css']
})
export class PageNasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
